(function(){

  "use strict";

  var emb_setup = function($) {
    var self = this;
    self.getCart = function() {
      return $.ajax({
        url: '/cart.js',
        dataType: "json",
        cache: false,
      });
    }

    self.getEmbroideryProductID = function(cart) {
      var id;
      $.each(cart.items, function(ind) {
        if(cart.items[ind].handle == 'add-embroidery') {
          id = cart.items[ind].variant_id;
        }
      });
      return id;
    }

    self.getTotalEmbroideryItems = function(cart) {
      var total = 0;

      if(cart.items.length > 0) {
        $.each(cart.items, function(ind) {
          var item = cart.items[ind];
          
          if(item.properties) {
            $.each(item.properties, function(property) {
              if(property == "_emb-url") {
                total++;
              }
            });
          }
        });
      }
      return total;
    }

    self.removeEmbroiderItem = function(cart) {

      // Get teh total form the cart ajax request
      var emb_line_item = $("#updating_cart #product-"+self.getEmbroideryProductID(cart));
      emb_line_item.find('.inline-cart-qty input').attr('readonly', true);

      // Only update if the totals returned are different
      var current = emb_line_item.find('.inline-cart-qty input').val();
      var total = self.getTotalEmbroideryItems(cart);

      if(current != total) {
        emb_line_item.find('.inline-cart-qty input').val(total)
          .trigger("input");
      }

    }

    self.updateCart = function(product_id) {
      $('a[href*="/products/add-embroidery"]').closest("li").find(".minus").remove();
      $('a[href*="/products/add-embroidery"]').closest("li").find(".plus").remove();

      // Update the cart each time it is updated
      $("body").on("cart-update", function(e, cart) {
        self.removeEmbroiderItem(cart);
      });

      self.getCart().then(function(cart) {
        self.removeEmbroiderItem(cart);
      });

    }
  }

  var load_script = function (url, callback){

    var script = document.createElement("script");
    script.type = "text/javascript";

    // If the browser is Internet Explorer.
    if (script.readyState){ 
      script.onreadystatechange = function(){
        if (script.readyState == "loaded" || script.readyState == "complete"){
          script.onreadystatechange = null;
          callback();
        }
      };
    // For any other browser.
    } else {
      script.onload = function(){
        callback();
      };
    }

    script.src = url;
    document.getElementsByTagName("head")[0].appendChild(script);
      
  };

  /* This is my app's JavaScript */
  var bootstrap = function($){
    
    $(document).ready(function() {
      
      var embsetup = new emb_setup($);
      embsetup.updateCart();

    });
    
  };

  if ((typeof jQuery === 'undefined') || (parseFloat(jQuery.fn.jquery) < 1.7)) {
    load_script('//ajax.googleapis.com/ajax/libs/jquery/1.9.1/jquery.min.js', function(){
      var jQuery191 = jQuery.noConflict(true);
      bootstrap(jQuery191);
    });
  } else {
    bootstrap(jQuery);
  }

})();